/* Generated by scripts/build-configurator-variant-map.js. */
window.SBC_VARIANT_ID_MAP = Object.freeze({
  "48793359909193": "54425122505041",
  "48793359941961": "54425122439505",
  "48793359974729": "54425122537809",
  "48793360007497": "54425122570577",
  "48793360040265": "54425122472273",
  "48793360236873": "54425122668881",
  "48793360269641": "54425122603345",
  "48793360302409": "54425122701649",
  "48793360335177": "54425122734417",
  "48793360367945": "54425122636113",
  "49545009856841": "54425122144593",
  "49545009922377": "54425121751377",
  "49545012150601": "54425121653073",
  "49545012183369": "54425121620305",
  "49545012216137": "54425121554769",
  "49545012248905": "54425121522001",
  "49545012281673": "54425121587537",
  "49545012314441": "54425121685841",
  "49545024930121": "54425121128785",
  "49545024962889": "54425121259857",
  "49545024995657": "54425120604497",
  "49545025028425": "54425120735569",
  "49545025061193": "54425120866641",
  "49545025093961": "54425121390929",
  "49545124184393": "54425121194321",
  "49545124217161": "54425121325393",
  "49545124249929": "54425120670033",
  "49545124282697": "54425120801105",
  "49545124315465": "54425120932177",
  "49545124348233": "54425121456465",
  "49545160556873": "54425119686993",
  "49545160622409": "54425119785297",
  "49545160819017": "54425118900561",
  "49545160884553": "54425118998865",
  "49545160950089": "54425119097169",
  "49545161015625": "54425119195473",
  "49545161212233": "54425120080209",
  "49545161277769": "54425120178513",
  "49545222881609": "54425118474577",
  "49545222914377": "54425118507345",
  "49545222947145": "54425118540113",
  "49545222979913": "54425118572881",
  "49545237332297": "54425118245201",
  "49545237365065": "54425118409041",
  "49545237397833": "54425118310737",
  "49545237463369": "54425118277969",
  "49545237496137": "54425118376273",
  "49545248473417": "54425117786449",
  "49545248506185": "54425117851985",
  "49545248538953": "54425117819217",
  "49545248571721": "54425117983057",
  "49545248604489": "54425117917521",
  "49545248637257": "54425117950289",
  "49545248702793": "54425118015825",
  "49545248735561": "54425118081361",
  "49545248768329": "54425118048593",
  "49545248801097": "54425118212433",
  "49545248833865": "54425118146897",
  "49545248866633": "54425118179665",
  "49545261121865": "54425117720913",
  "49545270788425": "54425117393233",
  "49545270821193": "54425117426001",
  "49545270853961": "54425117458769",
  "49545270886729": "54425117491537",
  "49545275441481": "54425117163857",
  "49545275474249": "54425117229393",
  "49545275507017": "54425117262161",
  "49545275539785": "54425117196625",
  "49545275572553": "54425117294929",
  "49545301524809": "54425116901713",
  "49545301557577": "54425116967249",
  "49545301590345": "54425116934481",
  "49545301623113": "54425117032785",
  "49545326231881": "54425117098321",
  "49545326297417": "54425117065553",
  "49545349792073": "54425116770641",
  "49545349824841": "54425116606801",
  "49545349857609": "54425116672337",
  "49545349890377": "54425116639569",
  "49545349923145": "54425116803409",
  "49545349955913": "54425116737873",
  "49545373581641": "54425106612561",
  "49545373614409": "54425106350417",
  "49545373647177": "54425106415953",
  "49545373679945": "54425106481489",
  "49545373712713": "54425106547025",
  "49545405071689": "54425116311889",
  "49555967672649": "54425117524305",
  "49660278833481": "54425119293777",
  "49660278899017": "54425119392081",
  "49660284633417": "54425119883601",
  "49660284698953": "54425119981905",
  "49785712836937": "54425115033937",
  "49785712869705": "54425114968401",
  "49785712902473": "54425115066705",
  "49785712935241": "54425115001169",
  "49785712968009": "54425115099473",
  "49785950404937": "54425114935633",
  "49991162691913": "54425114575185",
  "49991162757449": "54425114640721",
  "49992130527561": "54425118605649",
  "49992197931337": "54425118441809",
  "51109527978313": "54425113690449",
  "51109528011081": "54425113755985",
  "51109528043849": "54425113821521",
  "51109528076617": "54425113887057",
  "51109528109385": "54425113952593",
  "51109528142153": "54425113985361",
  "51918711750985": "54425113657681",
  "51980833521993": "54425109266769",
  "51980833554761": "54425109299537",
  "51980833587529": "54425109332305",
  "51980833620297": "54425109365073",
  "51980833653065": "54425109397841",
  "51980833685833": "54425109430609",
  "52094918230345": "54425113100625",
  "52094918263113": "54425113133393",
  "52094918295881": "54425113166161",
  "52094918328649": "54425113198929",
  "52094918361417": "54425113231697",
  "52094918394185": "54425113264465",
  "52095036227913": "54425112674641",
  "52095354077513": "54425111626065",
  "52095354110281": "54425111658833",
  "52095354143049": "54425111691601",
  "52095354175817": "54425111724369",
  "52096924746057": "54425111757137",
  "52098104754505": "54425109889361",
  "52098104787273": "54425109954897",
  "52098104820041": "54425110020433",
  "52098104852809": "54425110053201",
  "52098104918345": "54425110151505",
  "52112143581513": "54425117327697",
  "52133992530249": "54425109922129",
  "52133992563017": "54425109987665",
  "52133992628553": "54425110085969",
  "52133992661321": "54425110118737",
  "52133992694089": "54425110184273",
  "52315524366665": "54425108382033",
  "52315524399433": "54425108349265",
  "52315822981449": "54425107661137",
  "52479362826569": "54425106809169",
  "52479362859337": "54425106841937",
  "52479362892105": "54425106874705",
  "52479362924873": "54425106907473",
  "52479362957641": "54425106940241",
  "52518905315657": "54425113723217",
  "52518905348425": "54425113788753",
  "52518905381193": "54425113854289",
  "52518905413961": "54425113919825",
  "52518905479497": "54425114018129",
  "52817704878409": "54425106317649",
  "52817704911177": "54425106383185",
  "52817704943945": "54425106448721",
  "52817705009481": "54425106514257",
  "52817705042249": "54425106579793"
});
window.SBC_VARIANT_ID_MAP_META = Object.freeze({
  "referencedVariantIds": 190,
  "mappedVariantIds": 156,
  "unresolvedVariantIds": 34
});
